import { render } from "./IndicatorsWrapper.vue?vue&type=template&id=193c20c8&scoped=true&ts=true"
import script from "./IndicatorsWrapper.vue?vue&type=script&lang=ts"
export * from "./IndicatorsWrapper.vue?vue&type=script&lang=ts"

import "./IndicatorsWrapper.vue?vue&type=style&index=0&id=193c20c8&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193c20c8"]])

export default __exports__